import { render, staticRenderFns } from "./VploadImgThree.vue?vue&type=template&id=5a0fe7f6&scoped=true"
import script from "./VploadImgThree.vue?vue&type=script&lang=js"
export * from "./VploadImgThree.vue?vue&type=script&lang=js"
import style0 from "./VploadImgThree.vue?vue&type=style&index=0&id=5a0fe7f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0fe7f6",
  null
  
)

export default component.exports